module.exports = __webpack_public_path__ + "static/Elm-Street-Laundry-715-E-Elm-St-Burlington-NC-27215-efb40d9a52ebeae0aa2e1998e8745aec.jpg";